export default "__VITE_ASSET__eBB5uVE_t2Bb1etqpZE3Ig__";